module.exports = function() {
  return new Worker(__webpack_public_path__ + "d57f11ef08087d173c04.worker.js");
};